import { Injectable } from '@angular/core';
import { FeatureCollection, Feature, Geometry, GeoJSON, Point } from 'geojson';
import { MathAux } from '../math-aux/math-aux';
import { LegendComponent } from '../../legend/legend.component';
import { DiscreteLegendComponent } from '../../discrete-legend/discrete-legend.component';
import * as mapboxgl from 'mapbox-gl';
import { TimespanService } from '../timespan/timespan.service';

@Injectable({
  providedIn: 'root'
})
export class MapPainterService {

  segments_heatmap_rain: {segment_id:string,color:string, rainValue: number}[] = [];
  markers: mapboxgl.Marker[] = [];
  remove = false;
  private methodErrorMsg = 'Você deve implementar este método em uma subclasse.';
  timeColumns: {name: string, text: string}[] = [
    { name:'indice_pluv', text: 'Agora'},
    { name: 'quinzemin', text: '15 minutos'},
    { name: 'trintamin', text: '30 minutos'},
    { name: 'umahora', text: '1 Hora'},
    { name: 'seishoras', text: '6 Horas'},
    { name: 'dozehoras', text: '12 Horas'},
    { name: 'vintequatrohoras', text: '24 horas'},
    { name: 'quarentaoitohoras', text: '48 Horas'},
    { name: 'setentaduashoras', text: '72 Horas'},
    { name: 'noventaseishoras', text: '96 Horas'},
    { name: 'mes', text: '1 mês'}
  ]

  constructor(protected timespanService: TimespanService) { }

  /**
   * 
   * @param elemVal 
   * @param lastElemVal 
   * @param compareData 
   */
  getColor(elemVal: number, compareData: number[], zeroColor: string) : string{
    throw new Error(this.methodErrorMsg);
  }

  /**
   * 
   * @param legend 
   * @param title 
   * @param compareData 
   */
  setLegend(legend: LegendComponent|DiscreteLegendComponent, titleLines: string[], timestamp: string, compareData: number[]) {
    throw new Error(this.methodErrorMsg);
  }  
}